import styled from 'styled-components';
import { fontColorMixin } from '../../mixins/fontColorMixin';
export var StyledZillowLogo = /*#__PURE__*/styled.svg.withConfig({
  displayName: "StyledZillowLogo",
  componentId: "c11n-8-111-1__sc-yc584g-0"
})(["", ""], fontColorMixin);